module.exports = __webpack_public_path__ + "ph.14d23355000524b09ec9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ph.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ph.svg
// module chunks = styles